"use client"
import React from "react"
import { Sun, Moon } from "lucide-react"
import { useTheme } from "../theme/ThemeProvider"

export default function ThemeToggle() {
  const { theme, setTheme, toggleTheme } = useTheme()
  const isDark = (theme === "dark") ||
                 (theme === "system" && window.matchMedia &&
                  window.matchMedia("(prefers-color-scheme: dark)").matches)

  return (
    <div className="inline-flex items-center gap-2">
      <button
        onClick={toggleTheme}
        className="p-2 rounded-md border bg-white dark:bg-gray-800 dark:border-gray-700"
        title="Toggle theme"
      >
        {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </button>

      <select
        className="h-8 border rounded px-2 bg-white dark:bg-gray-800 dark:border-gray-700"
        value={theme}
        onChange={(e) => setTheme(e.target.value)}
        title="Theme mode"
      >
        <option value="light">Light</option>
        <option value="dark">Dark</option>
        <option value="system">System</option>
      </select>
    </div>
  )
}
